/* eslint-disable react/forbid-elements */
import React from 'react';
import { RightTray } from '../../elements';

export function RightSearchTray(props: { children: React.ReactNode; header: string }) {
    return (
        <RightTray>
            <div className="admin-form">
                <h4>{props.header}</h4>
                <hr className="short" />
                {props.children}
            </div>
        </RightTray>
    );
}
